import { useEffect, useState } from "react";
import { SimpleFormSelectOption } from "src/app/components/form/SimpleFormSelect";
import { SiteTransport } from "src/app/transports/site";

const useSiteByManagerOptions = (initialRequest = true) => {
    const [siteByManagerOptions, setSiteByManagerOptions] = useState<Array<SimpleFormSelectOption>>(
        []
    );
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    const fetch = () => {
        setLoading(true);
        SiteTransport.optionsByManager()
            .then((res) => {
                setSiteByManagerOptions(res);
                setLoading(false);
            })
            .catch((err) => setError(err))
            .finally(() => setLoading(false));
    };

    const refresh = () => {
        if (!loading) fetch();
    };

    useEffect(() => {
        if (initialRequest) {
            fetch();
        }
    }, []);

    return {
        siteByManagerOptions,
        refresh,
        loading,
        error,
    };
};
export default useSiteByManagerOptions;
